import { window, experiments, designConsts } from '@wix/native-pro-gallery-utils';
import { GALLERY_CONSTS } from 'pro-gallery-lib';
function getVerticalMarginsAndPaddings3(infoToClamp) {
  const singleInfoStyle = getComputedStyle(infoToClamp);
  let result = 0;
  result += getNumberFromPx(singleInfoStyle.paddingBottom);
  result += getNumberFromPx(singleInfoStyle.paddingTop);
  result += getNumberFromPx(singleInfoStyle.borderTop);
  result += getNumberFromPx(singleInfoStyle.borderBottom);
  result += getNumberFromPx(singleInfoStyle.marginBottom);
  result += getNumberFromPx(singleInfoStyle.marginTop);
  return result;
}
function clampInfo(_ref) {
  let {
    infoToClamp,
    availableHeight
  } = _ref;
  log(infoToClamp, 'CLAMP START availableHeight ' + availableHeight);
  let availableHeightWithoutPaddingBottomAndMarginBottom = availableHeight;
  const verticalPaddingsAndMargins = getVerticalMarginsAndPaddings3(infoToClamp);
  availableHeightWithoutPaddingBottomAndMarginBottom -= verticalPaddingsAndMargins;
  log(infoToClamp, `availableHeightWithoutPaddingBottomAndMarginBottom ${availableHeightWithoutPaddingBottomAndMarginBottom}`);
  if (availableHeightWithoutPaddingBottomAndMarginBottom < 0) {
    availableHeightWithoutPaddingBottomAndMarginBottom = 0;
  }
  const fontSize = parseInt(getCss(infoToClamp, 'font-size', 16), 10);
  const lineHeight = getLineHeightInPixels(getCss(infoToClamp, 'line-height', 'normal'), fontSize);
  log(infoToClamp, `clamp lineHeight: ${lineHeight}`);
  const numOfLines = Math.floor(availableHeightWithoutPaddingBottomAndMarginBottom / lineHeight);
  log(infoToClamp, `LHF clamp numOfLines: ${numOfLines}`);
  clampLinesOrHideIfNoSpace(infoToClamp, numOfLines);
  log(infoToClamp, 'CLAMP END');
}
function clampLinesOrHideIfNoSpace(infoToClamp, numOfLines) {
  const span = infoToClamp.querySelector('span');
  if (numOfLines === 0) {
    setCss(infoToClamp, {
      display: 'none'
    });
    return;
  }
  setCss(span, {
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
    overflow: 'hidden',
    '-webkit-line-clamp': numOfLines + ''
  });
}
function setCss(element, styles) {
  try {
    Object.assign(element.style, styles);
  } catch (e) {
    console.log('LHF set css error');
    //
  }
}
function getCss(element, rule, _default) {
  return window.getComputedStyle(element)[rule] || _default;
}
function getNumberFromPx(lineHeightValue) {
  return lineHeightValue && lineHeightValue.includes('px') ? parseInt(lineHeightValue, 10) : 0;
}
function getVerticalMarginsAndPaddings2(singleInfo) {
  const singleInfoStyle = getComputedStyle(singleInfo);
  if (!singleInfoStyle) {
    console.log('LHF no singleInfoStyle');
    return 0;
  }
  return ['marginTop', 'marginBottom', 'paddingTop', 'paddingBottom'].map(x => getNumberFromPx(singleInfoStyle.x)).reduce((prev, current) => prev + current, 0);
}
function getVerticalPaddings(singleInfo) {
  const singleInfoStyle = getComputedStyle(singleInfo);
  if (!singleInfoStyle) {
    return 0;
  }
  return getNumberFromPx(singleInfoStyle.paddingTop) + getNumberFromPx(singleInfoStyle.paddingBottom);
}
function getVerticalMargins(singleInfo) {
  const singleInfoStyle = getComputedStyle(singleInfo);
  if (!singleInfoStyle) {
    return 0;
  }
  return getNumberFromPx(singleInfoStyle.marginTop) + getNumberFromPx(singleInfoStyle.marginBottom);
}
function getLineHeightInPixels(lineHeightValue, fontSize) {
  fontSize = parseInt(fontSize, 10);
  if (lineHeightValue.includes('px')) {
    return parseInt(lineHeightValue, 10);
  } else {
    return fontSize * 1.2; // is case we get 'normal' multiply by 1.2
  }
}
function getSavedDisplay(element) {
  return element && element.getAttribute('data-display') || '-webkit-box';
}
function getPaddingsAndBorder(element) {
  const cs = window.getComputedStyle(element);
  if (cs == null) {
    console.log('LHF warning: getComputedStyle is null, return 0 paddings and borders');
    return {
      paddingX: 0,
      paddingY: 0,
      borderX: 0,
      borderY: 0
    };
  }
  const paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
  const paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
  const borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
  const borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
  return {
    paddingX,
    paddingY,
    borderX,
    borderY
  };
}
function getDimensions(element) {
  const {
    paddingX,
    paddingY,
    borderX,
    borderY
  } = getPaddingsAndBorder(element);
  return {
    width: element.clientWidth - paddingX - borderX,
    height: element.offsetHeight
  };
}
function getSections(textsContainer) {
  const x = textsContainer.querySelectorAll('.section');
  return Array.from(x);
}
function getInfosInsideSection(section) {
  return Array.from(section.querySelectorAll('.info-member'));
}
function hideEmptySections(textsContainer) {
  const sections = getSections(textsContainer);
  sections.forEach(section => {
    const infosInsideSection = getInfosInsideSection(section);
    if (infosInsideSection.length === 0) {
      setCss(section, {
        display: 'none'
      });
    }
  });
}
function log(el, message) {
  console.log(`LHF  ${el.classList.value}: ${message}`);
}
function fixSingleSection(section) {
  let sectionRemainingHeight = section.offsetHeight;
  log(section, 'sectionRemainingHeight start ' + sectionRemainingHeight);
  getInfosInsideSection(section).forEach(info => {
    sectionRemainingHeight = clampInfoIfNeeded(info, sectionRemainingHeight);
  });
}
function clampInfoIfNeeded(info, sectionRemainingHeight) {
  const infoHeightIncludingBordersAndPaddings = info.offsetHeight;
  const infoVerticalMargins = getVerticalMargins(info);
  const infoFullHeight = infoHeightIncludingBordersAndPaddings + infoVerticalMargins;
  log(info, `infoHeightIncludingBordersAndPaddings: ${infoHeightIncludingBordersAndPaddings}, infoVerticalMargins: ${infoVerticalMargins}. infoFullHeight: ${infoFullHeight}`);
  if (infoFullHeight > sectionRemainingHeight) {
    // not enough room for current info
    clampInfo({
      infoToClamp: info,
      availableHeight: sectionRemainingHeight
    });
    return 0;
  } else {
    return sectionRemainingHeight - infoFullHeight;
  }
}
export default fixSingleSection;
//# sourceMappingURL=NewLHF.js.map